import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getHashValue } from "../../../utils/getQueryValue";
import ShelfForm from "./ShelfForm";
import { Button } from "../../core/basic/Button";
import { Modal } from "../../core/basic/Modal";

const ShelfModal = (props) => {
  const { t } = useTranslation(["analytics", "common"]);
  const autoShow = getHashValue("new_shelf", "false");
  const autoKeyword = getHashValue("keyword");
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (autoShow.toLowerCase() === "true" && props.numOfShelfCredits > 0 && props.numOfShelves > 0) {
      setShow(true);
    }

    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [props.numOfShelfCredits, props.numOfShelves]);

  return (
    <>
      <Modal
        isOpen={show}
        onOpenChange={setShow}
        title={
          props.numOfShelves >= props.numOfShelfCredits ?
            t(($) => $.analytics.shelf["Subscription Limit Reached"])
          : t(($) => $.analytics.shelf["Create a New Shelf"])
        }
        css={{ width: props.numOfShelves >= props.numOfShelfCredits ? "60vw" : "90vw" }}
      >
        {props.loading ?
          t(($) => $.common["Loading..."])
        : <ShelfForm
            create
            closeModal={() => {
              setShow(false);
            }}
            data={props.data}
            brandData={props.brandData}
            categoryFilter={props.categoryFilter}
            updateShelfData={props.updateShelfData}
            numOfShelfCredits={props.numOfShelfCredits}
            numOfShelves={props.numOfShelves}
            fullLayout
            modalForm={true}
            setCategoryFilter={props.setCategoryFilter}
            autoKeyword={autoKeyword}
          />
        }
      </Modal>
      <Button
        onPress={() => {
          setShow(true);
        }}
      >
        {t(($) => $.analytics.shelf["Create a New Shelf"])}
      </Button>
    </>
  );
};

export default ShelfModal;
